import { combineReducers } from 'redux';

import teachers from './teacher/reducers';
import reports from './teacher/slices/emailReports/emailReportsSlice';
import modalViews from './teacher/slices/modalView/modalViewSlice';
import resultsGrid from './teacher/slices/resultsGrid/resultsGridSlice';

const rootReducer = combineReducers({
  reports: reports,
  teachers: teachers,
  modalViews: modalViews,
  resultsGrid: resultsGrid,
});

export type ApplicationState = ReturnType<typeof rootReducer>;

export default rootReducer;
